"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ProviderRating = void 0;
var _react = _interopRequireDefault(require("react"));
var _providerComponents = require("@kyruus/provider-components");
var _styles = require("./styles");
var _globals = require("../../lib/constants/globals");
const ProviderRating = _ref => {
  let {
    provider,
    reviewCallback,
    reviewUrl,
    isProfileDisabled,
    track
  } = _ref;
  const handleClickRatingReviewCount = e => {
    e.preventDefault();
    track(_globals.LOGGING.MESSAGE.VIEW_PROVIDER, {
      page_section: _globals.LOGGING.PAGE_SECTION.REVIEW_COUNT
    });
    reviewCallback(e);
  };
  if (provider.reviews) {
    const ratingReviewCountLinkId = `view-details-rating-count-${provider.id}`;
    const ratingReviewCountLabeledBy = `${ratingReviewCountLinkId} view-details-${provider.id}`;
    return /*#__PURE__*/_react.default.createElement(_styles.RatingsContainer, {
      "data-testid": "ProviderRating"
    }, /*#__PURE__*/_react.default.createElement(_providerComponents.RatingsAndReviewsSummary, {
      ariaProps: {
        ratingReviewCountLabeledBy,
        ratingReviewCountLinkId
      },
      handleClickRatingReviewCount: handleClickRatingReviewCount,
      providerReviews: provider.reviews,
      ratingReviewCountHref: reviewUrl,
      shouldHidePageAnchors: isProfileDisabled
    }));
  } else {
    return null;
  }
};
exports.ProviderRating = ProviderRating;
ProviderRating.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderRating"
};